module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"placeholder":"utilisateur@mail.com","label":"E-mail","errors":{"email":"Mauvais format de courriel","required":"Champ requis"}},"en":{"placeholder":"user@mail.com","label":"E-mail","errors":{"email":"Wrong e-mail format","required":"Required field"}}}')
  delete Component.options._Ctor
}
